import { Platform } from 'react-native';
const useDebug = () => {
  if (Platform.OS !== 'web') return false;
  return new URLSearchParams(window.location.search)?.get('debug') === 'true';
};

export default useDebug;
